<template>
  <div class="bot-menu-page min-w-0">
    <Head :title="__('Bot buttons')" />
    <Heading class="mb-4 md:mb-6">{{ __('Bot buttons') }}</Heading>
    <BotMenuApp
      :data-url="dataUrl"
      :save-url="saveUrl"
      :can-edit="canEdit"
    />
  </div>
</template>

<script setup>
import BotMenuApp from '../components/BotMenuApp.vue'

defineProps({
  dataUrl: {
    type: String,
    required: true,
  },
  saveUrl: {
    type: String,
    required: true,
  },
  canEdit: {
    type: Boolean,
    default: false,
  },
})
</script>
